import { GetYtdBilledRevenueResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import type { GetYtdBilledRevenueResponse } from '../../../../../libs/client/src/generated';
import { getPrivateApi } from '../../services/api';
import { USE_CACHE_HEADER } from '../../services/api/cache-headers';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useGetYtdBilledRevenue(
  customerId?: string,
  options?: CustomUseQueryOptions<GetYtdBilledRevenueResponse>,
) {
  return useQuery(
    queryKeys.ytdBilledRevenue(customerId),
    async () => {
      const api = getPrivateApi();
      const getYtdBilledRevenueResponse = await api.getYtdBilledRevenue(
        {
          customerId,
        },
        USE_CACHE_HEADER,
      );

      return GetYtdBilledRevenueResponseSchema.parse(getYtdBilledRevenueResponse);
    },
    options,
  );
}
